import React from "react";
import MuiPaper from "@mui/material/Paper";
import styles from "./Paper.module.css";

const Paper = React.forwardRef(function Paper(
  { children, className, elevation = 1, ...props },
  ref,
) {
  return (
    <MuiPaper
      ref={ref}
      className={`${styles.paper} ${className || ""}`}
      elevation={elevation}
      {...props}
    >
      {children}
    </MuiPaper>
  );
});

export default Paper;
